<template>
  <div style="height: 540px">
    <SchemaTablePage
      ref="tablePageRef"
      :form-props="{ labelPosition: 'left' }"
      layout-mode="dialog"
      :search-schema="searchSchema"
      :columns="tableColumns"
      :default-query="defaultQuery"
      :request="request"
      :build-params="buildParams"
      :parse-result="parseResult"
      :immediate="false"
    >
      <template #table-header>
        <div class="actions">
          <el-button size="mini" type="primary" @click="handleAdd">新增</el-button>
        </div>
      </template>

      <template #bindTime="{ row }">
        {{ row.created_at | formatTimestamp }}
      </template>
      <template #rowActions="{ row }">
        <el-button size="mini" type="text" @click="handleEdit(row)">编辑</el-button>
        <el-button size="mini" class="danger-button" type="text" @click="handleDelete(row.id)"
          >删除</el-button
        >
      </template>
    </SchemaTablePage>
    <BankAccountFormDialog
      :visible.sync="formDialogVisible"
      :is-edit="isEdit"
      :form-data="formData"
      @success="handleFormSuccess"
    ></BankAccountFormDialog>
  </div>
</template>

<script>
import { deletePaymentMethod, getPaymentMethodList } from '@/api/member/account'
import { formatTimestamp } from '@/utils/time'
import BankAccountFormDialog from './ManageBankAccountFormDialog.vue'
import SchemaTablePage from '@/components/SchemaTablePage'

export default {
  name: 'ManageBankAccountManageTabDialog',
  components: {
    BankAccountFormDialog,
    SchemaTablePage,
  },
  filters: {
    formatTimestamp,
  },
  props: {
    memberInfo: {
      type: Object,
      default: () => ({}),
    },
    targetInfo: {
      type: Object,
      default: () => ({}),
    },
    isActive: {
      type: Boolean,
      default: true,
    },
    resetKey: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      defaultQuery: {
        card_no: '',
      },
      searchSchema: [
        {
          prop: 'card_no',
          label: '提款账号',
          component: 'input',
          componentProps: { clearable: true },
        },
        {
          component: 'actions',
        },
      ],
      tableColumns: [
        { resizable: false, prop: 'card_no', label: '提款账号', minWidth: 140 },
        { resizable: false, prop: 'card_type', label: '银行名称', minWidth: 180 },
        { resizable: false, prop: 'pix_type', label: '账号类型', minWidth: 100 },
        {
          resizable: false,
          prop: 'created_at',
          label: '绑定时间',
          minWidth: 140,
          slot: 'bindTime',
        },
        {
          resizable: false,
          width: 100,
          fixed: 'right',
          align: 'center',
          label: '操作',
          slot: 'rowActions',
        },
      ],
      formDialogVisible: false,
      isEdit: false,
      formData: {
        id: '',
        card_type: '',
        pix_type: '',
        card_no: '',
        username: '',
        extra1: '',
        real_name: '',
        mobile: '',
        email: '',
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.tablePageRef?.reload?.()
    })
  },
  watch: {
    resetKey() {
      this.$nextTick(() => {
        this.$refs.tablePageRef?.search?.()
      })
    },
  },
  methods: {
    request(params) {
      return getPaymentMethodList(params)
    },
    buildParams({ query, page, limit }) {
      const params = {
        page,
        page_size: limit,
      }
      if (query?.card_no) params.card_no = query.card_no
      const uid = this.targetInfo?.uid
      if (uid) params.uid = uid
      return params
    },
    parseResult(response) {
      if (response && response.code === 0) {
        return {
          list: response.data?.list || [],
          total: response.data?.total || 0,
        }
      }
      this.$message.error(response?.message || response?.msg || '加载银行账户列表失败')
      return { list: [], total: 0 }
    },
    handleAdd() {
      this.isEdit = false
      this.formData = {
        id: '',
        card_type: '',
        pix_type: '',
        card_no: '',
        username: this.memberInfo?.username || this.memberInfo?.memberNo || '',
        extra1: '',
        real_name: '',
        mobile: '',
        email: '',
      }
      this.formDialogVisible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.formData = {
        id: row.id,
        card_type: row.card_type || '',
        pix_type: row.pix_type || '',
        card_no: row.card_no || '',
        username: row.username || '',
        extra1: row.extra1 || '',
        real_name: row.real_name || '',
        mobile: row.mobile || '',
        email: row.email || '',
      }
      this.formDialogVisible = true
    },
    async handleDelete(id) {
      this.$confirm('确定要删除该银行账户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          try {
            const response = await deletePaymentMethod({
              id: id,
            })
            if (response.code === 0) {
              this.$message.success('删除成功')
              this.$refs.tablePageRef?.reload?.()
            } else {
              this.$message.error('删除失败')
            }
          } catch (error) {
            this.$message.error('删除失败')
          }
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    handleFormSuccess() {
      this.$nextTick(() => {
        this.$refs.tablePageRef?.reload?.()
      })
    },
  },
}
</script>

<style scoped>
.bank-card-cell {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: underline;
  cursor: pointer;
}
</style>
